unit View.Sincronizacao_Servidor_Retaguarda.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, System.StrUtils, UPersonalizacao_Tabela, UWeb.Enum,
  UPersonalizacao_Tabela.Interfaces, UUtils;

type
  TFViewSincronizacao_Servidor_RetaguardaList = class(TForm)
    btNew: TButton;
    Sincronizacao_Servidor_RetaguardaDataset: TXDataWebDataSet;
    Sincronizacao_Servidor_RetaguardaDatasetid: TIntegerField;
    Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda: TStringField;
    Sincronizacao_Servidor_RetaguardaDatasettabela_servidor: TStringField;
    Sincronizacao_Servidor_RetaguardaDatasetexcluido: TBooleanField;
    Sincronizacao_Servidor_RetaguardaDatasetinclusao: TDateTimeField;
    Sincronizacao_Servidor_RetaguardaDatasetalteracao: TDateTimeField;
    Sincronizacao_Servidor_RetaguardaDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure WebFormShow(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewSincronizacao_Servidor_RetaguardaList: TFViewSincronizacao_Servidor_RetaguardaList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewSincronizacao_Servidor_RetaguardaList }

procedure TFViewSincronizacao_Servidor_RetaguardaList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewSincronizacao_Servidor_RetaguardaList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewSincronizacao_Servidor_RetaguardaList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewSincronizacao_Servidor_RetaguardaList, AElementID, Result, @AfterCreate);
end;

procedure TFViewSincronizacao_Servidor_RetaguardaList.edSearchKeyDown(
  Sender: TObject; var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewSincronizacao_Servidor_RetaguardaList.edSearchKeyUp(
  Sender: TObject; var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewSincronizacao_Servidor_RetaguardaList.tmrConsultaTimer(
  Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewSincronizacao_Servidor_RetaguardaList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewSincronizacao_Servidor_RetaguardaList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Sincronizacao_Servidor_RetaguardaDataset.Connection.Model.DefaultSchema.FindEntityType(Sincronizacao_Servidor_RetaguardaDataset.EntitySetName),
      Sincronizacao_Servidor_RetaguardaDataset.CurrentData
    );

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fa fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_sincronizacao');
  end;
end;

procedure TFViewSincronizacao_Servidor_RetaguardaList.WebDBTableControl1GetCellClass(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['tabela_retaguarda', 'tabela_servidor']) of
      0, 1: AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewSincronizacao_Servidor_RetaguardaList.WebDBTableControl1GetCellData(
  Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido']) of
      0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
    end;
  end;
end;

procedure TFViewSincronizacao_Servidor_RetaguardaList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('sincronizacao_servidor_retaguarda', 'active');
  TUtils.SetValorDicionarioClasses('sincronizacao_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_sincronizacao', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, Sincronizacao_Servidor_RetaguardaDataset,
    lcPaginator, lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'id desc';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewSincronizacao_Servidor_RetaguardaList.WebFormShow(
  Sender: TObject);
begin
  if not TUtils.PossuiPermissao(Sincronizacao_Servidor_RetaguardaDataset.EntitySetName.ToLower, TTipoPermissao.INSERIR) then
    btNew.Enabled := False;
end;

procedure TFViewSincronizacao_Servidor_RetaguardaList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.sincronizacao_servidor_retaguarda.list.pagination.info');
  btNew := TButton.Create('view.sincronizacao_servidor_retaguarda.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.sincronizacao_servidor_retaguarda.list.table');
  cbPageSize := TComboBox.Create('view.sincronizacao_servidor_retaguarda.list.cbPageSize');
  edSearch := TEdit.Create('view.sincronizacao_servidor_retaguarda.list.search');
  lcPaginator := TListControl.Create('view.sincronizacao_servidor_retaguarda.list.pagination');
  Sincronizacao_Servidor_RetaguardaDataset := TXDataWebDataSet.Create(Self);
  Sincronizacao_Servidor_RetaguardaDatasetid := TIntegerField.Create(Self);
  Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda := TStringField.Create(Self);
  Sincronizacao_Servidor_RetaguardaDatasettabela_servidor := TStringField.Create(Self);
  Sincronizacao_Servidor_RetaguardaDatasetexcluido := TBooleanField.Create(Self);
  Sincronizacao_Servidor_RetaguardaDatasetinclusao := TDateTimeField.Create(Self);
  Sincronizacao_Servidor_RetaguardaDatasetalteracao := TDateTimeField.Create(Self);
  Sincronizacao_Servidor_RetaguardaDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Sincronizacao_Servidor_RetaguardaDataset.BeforeLoadDFMValues;
  Sincronizacao_Servidor_RetaguardaDatasetid.BeforeLoadDFMValues;
  Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda.BeforeLoadDFMValues;
  Sincronizacao_Servidor_RetaguardaDatasettabela_servidor.BeforeLoadDFMValues;
  Sincronizacao_Servidor_RetaguardaDatasetexcluido.BeforeLoadDFMValues;
  Sincronizacao_Servidor_RetaguardaDatasetinclusao.BeforeLoadDFMValues;
  Sincronizacao_Servidor_RetaguardaDatasetalteracao.BeforeLoadDFMValues;
  Sincronizacao_Servidor_RetaguardaDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewSincronizacao_Servidor_RetaguardaList';
    Width := 546;
    Height := 423;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'Novo';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'tabela_servidor';
      Title := 'Tabela Servidor';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'tabela_retaguarda';
      Title := 'Tabela Retaguarda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Sincronizacao_Servidor_RetaguardaDataset.SetParentComponent(Self);
    Sincronizacao_Servidor_RetaguardaDataset.Name := 'Sincronizacao_Servidor_RetaguardaDataset';
    Sincronizacao_Servidor_RetaguardaDataset.EntitySetName := 'Sincronizacao_Servidor_Retaguarda';
    Sincronizacao_Servidor_RetaguardaDataset.Connection := DMConnection.ApiConnection;
    Sincronizacao_Servidor_RetaguardaDataset.Left := 72;
    Sincronizacao_Servidor_RetaguardaDataset.Top := 144;
    Sincronizacao_Servidor_RetaguardaDatasetid.SetParentComponent(Sincronizacao_Servidor_RetaguardaDataset);
    Sincronizacao_Servidor_RetaguardaDatasetid.Name := 'Sincronizacao_Servidor_RetaguardaDatasetid';
    Sincronizacao_Servidor_RetaguardaDatasetid.FieldName := 'id';
    Sincronizacao_Servidor_RetaguardaDatasetid.Required := True;
    Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda.SetParentComponent(Sincronizacao_Servidor_RetaguardaDataset);
    Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda.Name := 'Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda';
    Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda.FieldName := 'tabela_retaguarda';
    Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda.Required := True;
    Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda.Size := 255;
    Sincronizacao_Servidor_RetaguardaDatasettabela_servidor.SetParentComponent(Sincronizacao_Servidor_RetaguardaDataset);
    Sincronizacao_Servidor_RetaguardaDatasettabela_servidor.Name := 'Sincronizacao_Servidor_RetaguardaDatasettabela_servidor';
    Sincronizacao_Servidor_RetaguardaDatasettabela_servidor.FieldName := 'tabela_servidor';
    Sincronizacao_Servidor_RetaguardaDatasettabela_servidor.Required := True;
    Sincronizacao_Servidor_RetaguardaDatasettabela_servidor.Size := 255;
    Sincronizacao_Servidor_RetaguardaDatasetexcluido.SetParentComponent(Sincronizacao_Servidor_RetaguardaDataset);
    Sincronizacao_Servidor_RetaguardaDatasetexcluido.Name := 'Sincronizacao_Servidor_RetaguardaDatasetexcluido';
    Sincronizacao_Servidor_RetaguardaDatasetexcluido.FieldName := 'excluido';
    Sincronizacao_Servidor_RetaguardaDatasetinclusao.SetParentComponent(Sincronizacao_Servidor_RetaguardaDataset);
    Sincronizacao_Servidor_RetaguardaDatasetinclusao.Name := 'Sincronizacao_Servidor_RetaguardaDatasetinclusao';
    Sincronizacao_Servidor_RetaguardaDatasetinclusao.FieldName := 'inclusao';
    Sincronizacao_Servidor_RetaguardaDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Sincronizacao_Servidor_RetaguardaDatasetalteracao.SetParentComponent(Sincronizacao_Servidor_RetaguardaDataset);
    Sincronizacao_Servidor_RetaguardaDatasetalteracao.Name := 'Sincronizacao_Servidor_RetaguardaDatasetalteracao';
    Sincronizacao_Servidor_RetaguardaDatasetalteracao.FieldName := 'alteracao';
    Sincronizacao_Servidor_RetaguardaDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Sincronizacao_Servidor_RetaguardaDatasetexclusao.SetParentComponent(Sincronizacao_Servidor_RetaguardaDataset);
    Sincronizacao_Servidor_RetaguardaDatasetexclusao.Name := 'Sincronizacao_Servidor_RetaguardaDatasetexclusao';
    Sincronizacao_Servidor_RetaguardaDatasetexclusao.FieldName := 'exclusao';
    Sincronizacao_Servidor_RetaguardaDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Sincronizacao_Servidor_RetaguardaDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 328;
    tmrConsulta.Top := 136;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Sincronizacao_Servidor_RetaguardaDataset.AfterLoadDFMValues;
    Sincronizacao_Servidor_RetaguardaDatasetid.AfterLoadDFMValues;
    Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda.AfterLoadDFMValues;
    Sincronizacao_Servidor_RetaguardaDatasettabela_servidor.AfterLoadDFMValues;
    Sincronizacao_Servidor_RetaguardaDatasetexcluido.AfterLoadDFMValues;
    Sincronizacao_Servidor_RetaguardaDatasetinclusao.AfterLoadDFMValues;
    Sincronizacao_Servidor_RetaguardaDatasetalteracao.AfterLoadDFMValues;
    Sincronizacao_Servidor_RetaguardaDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
